import React from 'react'
import { Link } from 'react-scroll'

import './SidenavItem.css'
import { ReactScrollLinkProps } from 'react-scroll/modules/components/Link'

export type IconTypes = 'accept' | 'info'
export interface SidenavItemProps {
  id?: string
  label: string
  isSelected: boolean
  icon?: IconTypes
  key?: string
  linkProps: ReactScrollLinkProps
}

const SidenavItem: React.FC<SidenavItemProps> = ({ id, label, isSelected, icon, linkProps }) => (
  <Link
    {...linkProps}
    {...(id && { id: id, 'data-testid': id })}
    role='link'
    className={`sidenav-item inline-block vertical-center-container font-ellipsis background-white cursor-pointer button-text `}
  >
    <span
      className={`is24-icon-${
        icon ?? 'accept'
      } align-middle inline-block lap-padding-horizontal-s desk-padding-horizontal-m font-heading-small-regular margin-none ${icon ? '' : 'gray-icon'}`}
    />
    <span className={`${isSelected ? 'font-body-medium-bold' : 'font-body-medium-regular not-selected'}`}>
      {' '}
      {label}{' '}
    </span>
  </Link>
)

export default SidenavItem
